class Popup {
  constructor() {
    this.popup = document.querySelector('#popup');
    this.cookieName = this.popup.dataset.cookie;
    this.linkUrl = this.popup.dataset.linkUrl;
    this.expirationDate = this.popup.dataset.expirationDate;
    const cookie = this.getCookie('directors_lecture');

    if (cookie === '') {
      this.minimizeButton = document.querySelector('.popup__arrow');
      this.subscribeButton = document.querySelector('.popup__subscribe-button');
      this.subscribeText = document.querySelector('.popup__subscribe-text');
      this.close = document.querySelector('.popup__close');

      this.minimizeButton.addEventListener('click', this.togglePopup.bind(this));
      this.subscribeButton.addEventListener('click', this.subscribe.bind(this));
      this.subscribeText.addEventListener('click', this.subscribe.bind(this, true));
      this.close.addEventListener('click', this.cancel.bind(this));

      setTimeout(() => {
        const popupWrapper = document.querySelector('.popup__wrapper');
        popupWrapper.classList.toggle('open');

        setTimeout(() => {
          popupWrapper.classList.remove('open');
          popupWrapper.classList.add('show');
        }, 1100);
      }, 3000);
    }
  }

  togglePopup() {
    const popupWrapper = document.querySelector('.popup__wrapper');
    const upArrow = document.querySelector('.popup__arrow-up');
    const downArrow = document.querySelector('.popup__arrow-down');
    const minizedText = document.querySelector('.popup__minimized-text');

    if (popupWrapper.classList.contains('show')) {
      popupWrapper.classList.add('minimize');
      popupWrapper.classList.remove('show');

      setTimeout(() => {
        minizedText.classList.toggle('hidden');
      }, 1200);
    } else {
      if (popupWrapper.classList.contains('maximize')) {
        popupWrapper.classList.remove('maximize');
        popupWrapper.classList.add('minimize');

        setTimeout(() => {
          minizedText.classList.toggle('hidden');
        }, 1200);
      } else {
        popupWrapper.classList.remove('minimize');
        popupWrapper.classList.add('maximize');
        minizedText.classList.toggle('hidden');
      }
    }

    upArrow.classList.toggle('hidden');
    downArrow.classList.toggle('hidden');
  }

  subscribe(small = false) {
    window.open(`${ this.linkUrl }`);
    document.cookie = `${ this.cookieName }=true; expires=${ this.expirationDate };`;

    this.closePopup(small);
  }

  cancel() {
    document.cookie = `${ this.cookieName }=false; expires=${ this.expirationDate };`;

    this.closePopup();
  }

  closePopup(small = false) {
    const popupWrapper = document.querySelector('.popup__wrapper');

    if (small) {
      popupWrapper.classList.add('close-small');
      popupWrapper.classList.remove('minimize');
    } else {
      popupWrapper.classList.add('close');
      popupWrapper.classList.remove('maximize');
    }

    setTimeout(() => {
      this.popup.remove();
    }, 1500);
  }

  getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}

export default Popup;
